import { render, staticRenderFns } from "./addActivity.vue?vue&type=template&id=7212d23e"
import script from "./addActivity.vue?vue&type=script&lang=js"
export * from "./addActivity.vue?vue&type=script&lang=js"
import style0 from "./addActivity.vue?vue&type=style&index=0&id=7212d23e&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7212d23e')) {
      api.createRecord('7212d23e', component.options)
    } else {
      api.reload('7212d23e', component.options)
    }
    module.hot.accept("./addActivity.vue?vue&type=template&id=7212d23e", function () {
      api.rerender('7212d23e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/marketing/activity/addactivity/addActivity.vue"
export default component.exports